import { render, staticRenderFns } from "./PagadorSap.vue?vue&type=template&id=187cbbf0&"
import script from "./PagadorSap.vue?vue&type=script&lang=js&"
export * from "./PagadorSap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports